// Re-export the auto-generated Lovable Cloud client so legacy imports
// (`@/lib/supabase`) continue to work without a null client crash.
import { supabase } from '@/integrations/supabase/client'

export { supabase }

export const isSupabaseConfigured = (): boolean => true